import React, { useEffect, useState, useCallback } from 'react';
import './saude.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import PageHeader from '../../components/PageHeader';
import { useInternals } from '../../context/internalContext';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUsers } from '../../context/usersContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';

const EvolucaoSaude = () => {
  const location = useLocation();
  const { internalId } = location.state || {};
  const { listInternals, addHealthEvolution, listHealthEvolution, updateHealthEvolution } = useInternals();
  const { buildUnitReadParams } = useUsers();
  const [internalDetails, setInternalDetails] = useState(null);
  const [evolutionText, setEvolutionText] = useState('');
  const [evolutionDate, setEvolutionDate] = useState(() => new Date().toISOString().split('T')[0]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [evolutions, setEvolutions] = useState([]);
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);
  const [editingEvolution, setEditingEvolution] = useState(null);
  const [editForm, setEditForm] = useState({ date: '', notes: '' });
  const [isSavingEdit, setIsSavingEdit] = useState(false);

  const handleInternalSelect = (internal) => {
    setInternalDetails(internal);
  };

  const handleOpenEdit = (ev) => {
    setEditingEvolution(ev);
    setEditForm({ date: ev.date || '', notes: ev.notes || '' });
  };

  const handleSaveEdit = async () => {
    if (!editForm.notes.trim()) {
      toast.error('Preencha a evolução.');
      return;
    }
    setIsSavingEdit(true);
    try {
      await updateHealthEvolution(editingEvolution.id, { date: editForm.date, notes: editForm.notes.trim() });
      setEditingEvolution(null);
      loadEvolutions(internalDetails.id);
    } catch (_) {
      // toast tratado no context
    } finally {
      setIsSavingEdit(false);
    }
  };

  const loadEvolutions = useCallback(async (id) => {
    if (!id) return;
    try {
      const response = await listHealthEvolution(id);
      setEvolutions(response?.results || response || []);
    } catch (err) {
      // toast tratado no context
    }
  }, [listHealthEvolution]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!internalDetails?.id) {
      toast.error('Selecione um interno para registrar a evolução.');
      return;
    }
    if (!evolutionText.trim()) {
      toast.error('Preencha a evolução.');
      return;
    }
    setIsSubmitting(true);
    try {
      await addHealthEvolution({
        internal: internalDetails.id,
        notes: evolutionText.trim(),
        date: evolutionDate,
      });
      setEvolutionText('');
      setEvolutionDate(new Date().toISOString().split('T')[0]);
      loadEvolutions(internalDetails.id);
    } catch (error) {
      // Toast já tratado na context
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (internalId) {
      (async () => {
        try {
          const response = await listInternals(buildUnitReadParams({ id: internalId }));
          const internal = response?.results?.[0];
          if (internal) setInternalDetails(internal);
        } catch (err) {
          console.error('Erro ao carregar interno:', err);
        }
      })();
    }
  }, [internalId, listInternals, buildUnitReadParams]);

  useEffect(() => {
    if (internalDetails?.id) {
      loadEvolutions(internalDetails.id);
    } else {
      setEvolutions([]);
    }
  }, [internalDetails, loadEvolutions]);

  return (
    <div>
      {editingEvolution && (
        <div className="modal-overlay" onClick={() => setEditingEvolution(null)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <h5 className="modal-title">Editar Evolução</h5>
            <div className="social-form-group">
              <label>Data</label>
              <input
                type="date"
                value={editForm.date}
                onChange={(e) => setEditForm((f) => ({ ...f, date: e.target.value }))}
              />
            </div>
            <div className="social-form-group">
              <label>Evolução</label>
              <textarea
                rows="4"
                value={editForm.notes}
                onChange={(e) => setEditForm((f) => ({ ...f, notes: e.target.value }))}
              />
            </div>
            <div className="modal-actions">
              <button className="social-submit-button" onClick={handleSaveEdit} disabled={isSavingEdit}>
                {isSavingEdit ? 'Salvando...' : 'Salvar'}
              </button>
              <button className="modal-cancel-btn" onClick={() => setEditingEvolution(null)}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
      <Sidebar />
      <Header />
      <div className='container social-container admission-page'>
        <Titulo
          children={
            <SearchInternal
              onSelect={handleInternalSelect}
              onSelectingChange={setIsSelectingInternal}
            />
          }
        />

        <PageHeader
          title="Evolução"
          subtitle="Registro de evolução clínica do interno."
          internalDetails={internalDetails}
        />

        {isSelectingInternal ? (
          <InternalDataSkeleton />
        ) : (
          <div className="evolucao-container content" >
          <div className='social-form-group'>
            <label>Data</label>
            <input
              type="date"
              value={evolutionDate}
              onChange={(e) => setEvolutionDate(e.target.value)}
            />
          </div>
          <div className='social-form-group'>
            <label>Registrar Evolução</label>
            <textarea
              name="evolution"
              rows="4"
              value={evolutionText}
              onChange={(e) => setEvolutionText(e.target.value)}
              placeholder="Descreva a evolução do interno"
            />
            <button className="social-submit-button" onClick={handleSubmit} disabled={isSubmitting}>
              {isSubmitting ? 'Salvando...' : 'Adicionar Evolução'}
            </button>
          </div>
          <div className="timeline">
            <h4>Evoluções</h4>
            <ul className="timeline-list">
              {evolutions.length > 0 ? (
                evolutions.map((ev) => (
                  <li key={ev.id || `${ev.date}-${ev.data}`} className="timeline-item">
                    <div className="timeline-date">
                      {ev.date
                        ? (() => { const [y, m, d] = String(ev.date).slice(0, 10).split('-'); return `${d}/${m}/${y}`; })()
                        : ''}
                      <button
                        type="button"
                        className="timeline-edit-btn"
                        onClick={() => handleOpenEdit(ev)}
                        title="Editar evolução"
                      >
                        <FontAwesomeIcon icon={faPencil} />
                      </button>
                    </div>
                    <div className="timeline-content">
                      <p className="timeline-title">
                        <strong>Profissional:</strong>{' '}
                        {ev.health_professional_detail?.full_name || ev.full_name || 'Não informado'}
                      </p>
                      <p><strong>Nota:</strong> {ev.notes || ev.data || ''}</p>
                    </div>
                  </li>
                ))
              ) : (
                <p>Nenhuma evolução registrada.</p>
              )}
            </ul>
          </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EvolucaoSaude;
